// import { useEffect } from "react";
// import { Link } from "react-router-dom";

// theme
import Landing from "../../../themes";
import React from "react";
import TestimonialTalent from "../../../components/elements/TestimonialTalent";

const CandidateTestimonials: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // useEffect(() => {
  //   window.scroll(0, 600);
  // }, []);

  return (
    <Landing>
      <section className="w-[100%] my-5 px-3 md:px-14 font-abel text-center">
        <div className="md:pr-[65px] flex justify-end">
          {/* <Link
            to="https://25thblue.com"
            className="text-[#0B60D6] md:text-[18px] text-[16px] border-[1px] border-[black] hover:bg-[#CDD8FE] hover:text-[#243677] py-2 px-4 rounded ml-3 md:ml-5 mt-2"
          >
            25th Blue
          </Link> */}
        </div>
      </section>
      <article
        id="testimonials"
        className="md:h-[511px] bg-[#000000] font-abel text-[white] border-t border-[#ffffff]"
      >
        <div className="flex w-full md:pb-[100px] justify-between items-center">
          <TestimonialTalent />
        </div>
      </article>
    </Landing>
  );
};

export default CandidateTestimonials;
